import {
    formatError,
    login,
    runLogoutTimer,
    saveTokenInLocalStorage,
    signUp,
} from '../../services/AuthService';
import { toast } from "react-toastify";

// Action Types
export const SIGNUP_CONFIRMED_ACTION = '[signup action] confirmed signup';
export const SIGNUP_FAILED_ACTION = '[signup action] failed signup';
export const LOGIN_CONFIRMED_ACTION = '[login action] confirmed login';
export const LOGIN_FAILED_ACTION = '[login action] failed login';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';
export const LOGOUT_ACTION = '[Logout action] logout action';

// Signup Action
export function signupAction(email, password, navigate) {
    return (dispatch) => {
        signUp(email, password)
            .then((response) => {
                saveTokenInLocalStorage(response.data);

                dispatch(confirmedSignupAction(response.data));
                runLogoutTimer(dispatch, 3600 * 1000, navigate); // 1-hour session

                const role = response.data.user?.role;
                if (role === 'veeadmin') {
                    navigate('/vee-admin-dashboard');
                } else {
                    navigate('/vee-admin-dashboard');
                }
            })
            .catch((error) => {
                const errorMessage = formatError(error.response.data);
                dispatch(signupFailedAction(errorMessage));
            });
    };
}

// Login Action
// export function loginAction(email, password, role, navigate) {
//     return (dispatch) => {
//         login(email, password, role)  // pass role to choose correct API
//             .then((response) => {
//                 saveTokenInLocalStorage(response.data);
//                 dispatch(loginConfirmedAction(response.data));

//                 runLogoutTimer(dispatch, 3600 * 1000, navigate); // 1-hour session

//                 const userRole = response.data.user?.role;

//                 if (userRole === 'superadmin') {
//                     navigate('/super-admin-dashboard');
//                 } else if (userRole === 'cityadmin' || userRole === 'citymanager') {
//                     navigate('/city-dashboard');
//                 } else {
//                     navigate('/dashboard'); // fallback
//                 }
//             })
//             .catch((error) => {
//                 const errorMessage = formatError(error.response?.data || {});
//                 dispatch(loginFailedAction(errorMessage));
//             });
//     };
// }
export function loginAction(email, password, role, navigate) {
  return (dispatch) => {
    login(email, password, role)
      .then((response) => {
        saveTokenInLocalStorage(response.data);
        dispatch(loginConfirmedAction(response.data));
        toast.success(response.data.message || "Login successful ✅");

        runLogoutTimer(dispatch, 3600 * 1000, navigate); // 1 hour

        const userRole = response.data.user?.role;

        if (userRole === 'veeadmin') {
          navigate('/vee-admin-dashboard');
        } else if (userRole === 'user' || userRole === 'citymanager') {
          navigate('/warehouse-dashboard');
        } else if (userRole === 'shopadmin' || userRole === 'shopmanager') {
          navigate('/vendor-dashboard');
        } else {
          navigate('/vee-admin-dashboard'); // fallback
        }
      })
      .catch((error) => {
        const errorMessage = error?.response?.data?.message || "Login failed";
        dispatch(loginFailedAction(errorMessage));
        toast.error(errorMessage);
      });
  };
}



// Logout
export function Logout(navigate) {
    const role = localStorage.getItem('role'); // directly get role

    // Clear everything
    localStorage.clear();

    // Redirect based on role
    if (role === 'user' || role === 'citymanager') {
        navigate('/warehouse/login');
    } else if (role === 'shopadmin' || role === 'shopmanager') {
        navigate('/shopvendor/login');
    } else {
        navigate('/warehouse/login');
    }

    return {
        type: LOGOUT_ACTION,
    };
}


// Action Creators
export function loginConfirmedAction(data) {
    return {
        type: LOGIN_CONFIRMED_ACTION,
        payload: data,
    };
}

export function loginFailedAction(data) {
    return {
        type: LOGIN_FAILED_ACTION,
        payload: data,
    };
}

export function confirmedSignupAction(data) {
    return {
        type: SIGNUP_CONFIRMED_ACTION,
        payload: data,
    };
}

export function signupFailedAction(message) {
    return {
        type: SIGNUP_FAILED_ACTION,
        payload: message,
    };
}

export function loadingToggleAction(status) {
    return {
        type: LOADING_TOGGLE_ACTION,
        payload: status,
    };
}
